<div style="margin-top: 10px;" id="tags-container" (click)="openTagManager()">
  <span
          *ngFor="let tag of tags | slice:0:5"
          style="display:inline-block;background:#e0e0e0;color:#333;padding:4px 10px;border-radius:12px;margin:0 5px 5px 0;"
  >
    {{ tag }}
  </span>
    <span *ngIf="tags.length > 5" style="font-weight: bold; font-size: 18px; vertical-align: middle;">
    ...
  </span>
    <span *ngIf="tags.length == 0" style="font-weight: bold; font-size: 18px; vertical-align: middle;">+</span>
</div>
